import React from "react";
import  { useState, useEffect } from 'react';
import './classes/BasketballEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const DavidSauriolTestimonial = () => {

    const app_url = configData.APP_URL;
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Promise.all([

        ])
        .then(() => {
     
        setIsLoading(false);
        })
    },[]);

    const doBackAway = () => {
        if (window.history.length > 1) {
            navigate(-1); // Go back
        } else {
            navigate('/'); // Fallback to home
        }
    };
    
    return (
        <>
        {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" style={{minHeight: "400px"}} className="david-sauriol-testimonial-main">
                <Helmet><title>David Sauriol</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div style={{float: "left"}}>
                        <img src="/basic/web/images/scout/picture-569910-1549563297.jpg" alt="Steve Wisensale, Ph.D." style={{"width":"78px"}} />
                    </div>
                    <div style={{float:"left", paddingLeft:"2%", paddingTop:"2%"}}><strong>David Sauriol</strong></div>
                    <div style={{textAlign: "right"}}><a href onClick={doBackAway} style={{cursor: "pointer"}}>« Back</a></div>
                    <div style={{clear:"both"}}></div>
                    <div style={{marginBottom: "8px"}}>
                        <p style={{marginTop: "0px"}}>
                            For those interested in getting experience in scouting, I fully endorse the SMWW/ Netscouts apprenticeship. One thing that holds people back from their dreams of working in professional basketball is actually getting the real work experience. Other SMWW classes allow aspiring basketball professionals to learn specific skills this program allows you to actually apply them.  The media access that this apprenticeship provides is the real cherry on top, it gave me just what I needed, more access to the Raptor 905. 
                        </p>
                    </div>
                </div>
                <div className="right">
                      {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                        {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default DavidSauriolTestimonial;